(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("Redux"));
	else if(typeof define === 'function' && define.amd)
		define("JSONFormsCore", ["Redux"], factory);
	else if(typeof exports === 'object')
		exports["JSONFormsCore"] = factory(require("Redux"));
	else
		root["JSONFormsCore"] = factory(root["Redux"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__354__) {
return 